import { mapActions, mapGetters, mapMutations } from 'vuex'
import globalConfig from '../utiles/globalConfig'
import { post } from '../store/ultile'
import ajax from '../config/ajax'
import { v4 as uuidv4 } from 'uuid'

export const isDana = globalConfig.getHrefParam('pt') == 'dana'
export default {
  data() {
    return {
      isDana: isDana, // 是否是Dana平台
      isLoadingPay: false, // 是否正在支付
      visibleDanaGetAuthPopup: false, // 是否显示授权提示弹窗
      payParams: null, // 支付参数
      LOCAL_STORAGE_DANA_UUID_KEY: 'dana_tourist_uuid'
    }
  },
  computed: {
    ...mapGetters([
      'letter',
      'gameId',
      'platform',
      'lang',
      'serverId',
      'roleId',
      'roleName',
      'sdkParams',
      'userName',
      'userId',
      'originUserType',
      'isUpgrade',
      'isBindDana'
    ])
  },
  methods: {
    ...mapMutations(['updateToAccountUpgrade']),
    ...mapActions(['judgeIsLogin', 'refreshUserJson', 'touristLogin', 'danaLogin', 'danaBind']),
    loadDanaSdk() {
      if (document.getElementById('danaSdk')) {
        return
      }
      const script = document.createElement('script')
      script.id = 'danaSdk'
      script.type = 'text/javascript'
      script.src =
        'https://cdn.marmot-cloud.com/npm/hylid-bridge/1.0.5/index.js'
      const headEle = document.getElementsByTagName('head')[0]
      headEle && headEle.appendChild(script)
    },
    onMessageFromDana() {
      if (window.my && window.my.onMessage) {
        my.onMessage = e => {
          console.log('Get Message From Dana', e)
          this[e.action](e.data)
        }
      } else {
        setTimeout(() => {
          this.onMessageFromDana()
        }, 1000)
      }
    },
    sendMessageToDana(data) {
      if (typeof my !== 'undefined' && my.postMessage) {
        console.log('Sending message to Dana', data)
        my.postMessage(data)
      } else {
        console.error('my.postMessage is not available')
      }
    },
    startLoading(tip = '') {
      this.sendMessageToDana({ action: 'startLoading', data: tip })
    },
    endLoading() {
      this.sendMessageToDana({ action: 'endLoading' })
    },
    showFailToast(tip = '') {
      this.sendMessageToDana({ action: 'showFailToast', data: tip })
    },
    openDanaWebview(url) {
      if (!/^(http|https):/.test(url)) {
        url = `https:${url}`
      } else if (/^http:/.test(url)) {
        url = url.replace('http:', 'https:')
      }
      this.sendMessageToDana({ action: 'openWebview', data: url })
    },
    getDanaAuthCodeForLogin() {
      this.startLoading()
      this.sendMessageToDana({ action: 'getAuthCodeForLogin' })
    },
    getDanaAuthCodeForBind() {
      this.startLoading()
      this.sendMessageToDana({ action: 'getAuthCodeForBind' })
    },
    async loginDana(data) {
      const { danaAppId, danaAuthCode } = data
      if (danaAppId && danaAuthCode) {
        try {
          await this.danaLogin({
            danaAppId,
            danaAuthCode
          })
          await this.judgeIsLogin({
            isCheck: true,
            isFirst: false
          })
        } catch (e) {
          this.showFailToast(e.msg)
        }
      } else {
        this.showFailToast('Login failed: User canceled')
      }
      this.endLoading()
      return Promise.resolve()
    },
    async bindDana(data) {
      const { danaAppId, danaAuthCode } = data
      if (danaAppId && danaAuthCode) {
        try {
          await this.danaBind({
            uid: this.userId,
            danaAppId,
            danaAuthCode
          })
          await this.refreshUserJson()
          this.submitDanaPay(this.payParams)
          this.handleVisibleDanaGetAuthPopup(false)
        } catch (e) {
          this.showFailToast(e.msg)
        }
      } else {
        console.log('Bind failed: User canceled')
      }
      this.endLoading()
      return Promise.resolve()
    },
    async touristLoginDana() {
      let danaTouristUUID = window.localStorage.getItem(
        this.LOCAL_STORAGE_DANA_UUID_KEY
      )
      if (!danaTouristUUID) {
        danaTouristUUID = uuidv4()
      }
      try {
        await this.touristLogin({
          machineId: danaTouristUUID,
          loginId: danaTouristUUID,
          remenber: true
        })
        await this.judgeIsLogin({
          isCheck: true,
          isFirst: false
        })
        // 登录成功了才存进去
        window.localStorage.setItem(
          this.LOCAL_STORAGE_DANA_UUID_KEY,
          danaTouristUUID
        )
      } catch (e) {
        this.showFailToast(e.msg)
      }
    },
    danaPay(params) {
      if (
        // 游客模式：绑定了DANA或者升级了平台账号
        (this.isUpgrade || this.isBindDana) ||
        // 账密模式登录
        +this.originUserType === 0 ||
        // 已授权dana登录
        +this.originUserType === 19) {
        this.submitDanaPay(params)
      } else {
        this.payParams = params || null;
        this.handleVisibleDanaGetAuthPopup(true)
      }
    },
    async submitDanaPay(params) {
      if (this.isLoadingPay) return
      this.isLoadingPay = true
      this.startLoading()
      try {
        const submitParams = {
          productId: params.productId,
          cpProductId: params.cpProductId,
          productDesc: params.productName,
          localMoney: params.price,
          localCurrency: params.currency,
          cpOrderId: params.order_no,
          serverId: params.serverId,
          roleId: params.roleId,
          roleName: encodeURIComponent(params.roleName),
          packageName: globalConfig.getHrefParam('packageName'),
          userId: this.userId,
          gameId: this.gameId,
          f_pay_type: 'waffo_dana',
          paytype: 'waffo_dana',
          location: 'ID',
          ptCode: 'global',
          pageSource: 'h5',
          isWeb: '1',
          devicePlate: window.isPhone ? 'wap' : 'pc'
        }
        const submitRes = await post(ajax.dana.pay.submit, submitParams, {
          withCredentials: true
        })
        if (submitRes.errmsg) {
          this.showFailToast(submitRes.errmsg)
        } else {
          this.sendMessageToDana({
            action: 'pay',
            data: submitRes.data.redirect_url
          })
        }
      } catch (e) {
        this.showFailToast(e.message)
        console.error(e)
      } finally {
        this.endLoading()
        this.isLoadingPay = false
      }
    },
    handleVisibleDanaGetAuthPopup(visible) {
      this.visibleDanaGetAuthPopup = visible
      if (!visible) {
        this.payParams = null
      }
    },
    closeDanaGetAuthPopup() {
      this.submitDanaPay(JSON.parse(JSON.stringify(this.payParams)))
      this.handleVisibleDanaGetAuthPopup(false)
    },
    upgradePlatformAccount() {
      this.$store.commit('updateToAccountUpgrade', 1)
      this.$store.commit('updateAsidePopupState', true)
    },
    async danaAccountUpgradeSuccess() {
      // 收到用户中心的：账号升级成功后，关闭用户中心，继续支付
      this.$store.commit('updateAsidePopupState', false)
      await this.refreshUserJson()
      this.submitDanaPay(JSON.parse(JSON.stringify(this.payParams)))
      this.handleVisibleDanaGetAuthPopup(false)
    },
    // TODO:测试使用
    // clearUUID() {
    //   window.localStorage.removeItem('dana_tourist_uuid')
    //   this.showFailToast('已清除游客UUID')
    // }
  }
}
